const mainClassName = 'item-select-counter';
const hiddenClassName = `${mainClassName}_hidden`;
const amountClassName = `${mainClassName}__amount`;
const plusClassName = `${mainClassName}__plus`;
const minusClassName = `${mainClassName}__minus`;
const getIdName = (id) => `itemSelectCounter-${id}`;

const getItem = (id) => document.querySelector(`#${getIdName(id)}`);

const getAmountItem = (id) => document.querySelector(`#${getIdName(id)} .${amountClassName}`);

const getPlusItem = (id) => document.querySelector(`#${getIdName(id)} .${plusClassName}`);

const getMinusItem = (id) => document.querySelector(`#${getIdName(id)} .${minusClassName}`);

const getMainClassName = ({ isShow }) => {
  let className = mainClassName;
  if (!isShow) {
    className += ` ${hiddenClassName}`;
  }
  return className;
};

export function render({ id, amount = 0, isShow = true }) {
  return `
    <div class="${getMainClassName({ isShow })}" id="${getIdName(id)}">
      <div class="${amountClassName}">${amount}</div>
      <div class="${plusClassName}">+</div>
      <div class="${minusClassName}">-</div>
    </div>
  `;
}

export function show(id) {
  const $elem = getItem(id);
  $elem.classList.remove(hiddenClassName);
}

export function hide(id) {
  const $elem = getItem(id);
  $elem.classList.add(hiddenClassName);
}

export function updateAmount(id, amount = 0) {
  const $elem = getAmountItem(id);
  $elem.innerHTML = amount;
}

export function onClickPlus(id, cb) {
  const $elem = getPlusItem(id);
  if (!$elem) return;
  $elem.addEventListener('click', (e) => {
    e.stopPropagation();
    cb(id);
  });
}

export function onClickMinus(id, cb) {
  const $elem = getMinusItem(id);
  if (!$elem) return;
  $elem.addEventListener('click', (e) => {
    e.stopPropagation();
    cb(id);
  });
}
